import { createAction } from "@reduxjs/toolkit";

export const loggerActions = {
  log: createAction<string>("logger/log"),
};
